import React, { useState } from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";

export default function AddEmployee() {
  const [employee, setEmployee] = useState({
    name: "",
    email: "",
    department: "",
    role: "",
    status: "Active",
  });

  const handleChange = (e) => {
    setEmployee({ ...employee, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("New Employee Data:", employee);
    alert("Employee added successfully!");
    setEmployee({ name: "", email: "", department: "", role: "", status: "Active" });
  };

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Add New Employee</h1>

        <Card>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-700 font-semibold mb-1">Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={employee.name}
                  onChange={handleChange}
                  required
                  className="w-full border p-2 rounded-md"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={employee.email}
                  onChange={handleChange}
                  required
                  className="w-full border p-2 rounded-md"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-1">Department</label>
                <select
                  name="department"
                  value={employee.department}
                  onChange={handleChange}
                  required
                  className="w-full border p-2 rounded-md"
                >
                  <option value="">Select Department</option>
                  <option value="HR">HR</option>
                  <option value="Sales">Sales</option>
                  <option value="Marketing">Marketing</option>
                  <option value="Development">Development</option>
                </select>
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-1">Role</label>
                <input
                  type="text"
                  name="role"
                  value={employee.role}
                  onChange={handleChange}
                  required
                  className="w-full border p-2 rounded-md"
                />
              </div>

              <div>
                <label className="block text-gray-700 font-semibold mb-1">Status</label>
                <select
                  name="status"
                  value={employee.status}
                  onChange={handleChange}
                  className="w-full border p-2 rounded-md"
                >
                  <option value="Active">Active</option>
                  <option value="On Leave">On Leave</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
            </div>

            <div>
              <Button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded-md">
                Add Employee
              </Button>
            </div>
          </form>
        </Card>
      </div>
    </HrLayout>
  );
}
